(function() {
    /* globals $, angular */
    'use strict';

    angular.module('dashboardApp').controller('loginController', Controller);
    Controller.$inject = [
        '$cookies',
        '$routeParams',
        'Login',
        'Routing',
        '$location',
    ];

    function Controller (
        $cookies,
        $routeParams,
        Login,
        Routing,
        $location
    ) {

        var vm = this;

        vm.showLogin = true;
        vm.showProgress = false;
        vm.error = null;

        vm.userName = null;
        vm.password = null;
        vm.rememberMe = false;



        vm.onSubmit = function() {
            vm.showLogin = false;
            vm.showProgress = true;
            vm.error = null;

            setRememberMe();

            Login.authenticate(vm.userName, vm.password, '').then(function(success) {
                if (success) {
                    Routing.apps();
                } else {
                    vm.showLogin = true;
                    vm.showProgress = false;
                    vm.error = 'Login failed';
                }
            });
        };


        function getRememberMe() {
            var userName = $cookies.get('rememberMe');
            if (userName) {
                vm.userName = userName;
                vm.rememberMe = true;
            }
        }

        function setRememberMe() {
            function oneYear() {
                var result = new Date();
                result.setDate(result.getDate() + 365);
                return result;
            }

            var options = {
                path: '/',
                expires: oneYear()
            };

            if (vm.rememberMe) {
                $cookies.put('rememberMe', vm.userName, options);
            } else {
                $cookies.put('rememberMe', undefined, options);
                // $cookies.remove('rememeberMe', { path: '/' });
            }
        }


        function autoLogin(){
            // Check for auto-login parameters
            if ($routeParams.email && $routeParams.hash){
                // Login
                vm.userName = $routeParams.email;
                vm.password = $routeParams.hash;
                
                vm.showLogin = false;
                vm.showProgress = true;
                vm.error = null;

                $routeParams.email = " ";
                $routeParams.hash = " ";

                Login.authenticate(vm.userName, vm.password, $routeParams.impersonatedBy).then(function (success) {
                     if (success) {
                        $location.search({});
                        // Redirect to app list
                        Routing.apps();
                    } else {                        
                        vm.showLogin = true;
                        vm.showProgress = false;
                        vm.error = 'Login failed';
                    }
                });
            }
        }


        //----------- initialization ------------------

        function init() {
            autoLogin();
            getRememberMe();
        }


        init();


    }



})();
